import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const DepartmentList = Loadable(lazy(() => import("./DepartmentList")));
const DepartmentForm = Loadable(lazy(() => import("./DepartmentForm")));

const departmentRoutes = [
  {
    path: "/Department/DepartmentList",
    element: <DepartmentList />,
    permission: PERMISSIONS.Departments.Menu,
  },
  {
    path: "/Department/DepartmentForm",
    element: <DepartmentForm />,
  },
  {
    path: "/Department/DepartmentForm/:departmentId",
    element: <DepartmentForm />,
  },
];

export default departmentRoutes;
